<template>
  <div>
    <v-btn @click="back" text class="text_btn">
      <v-icon>keyboard_arrow_left</v-icon>back
    </v-btn>
    <v-container>
      <h1>Profile</h1>
      <v-layout row wrap>
        <v-flex xs12 sm6 md4 style="margin-top:40px;">
          <h2>Contact information</h2>
          <v-form @submit="saveDetails">
            <v-text-field disabled v-model="email" placeholder="Email" label="E-Mail" />
            <v-text-field v-model="firstName" placeholder="First name" label="First name" />
            <v-text-field v-model="lastName" placeholder="Last name" label="Last name" />
            <v-btn type="submit">
              <v-icon>save</v-icon>Save
            </v-btn>
          </v-form>
        </v-flex>
        <v-flex xs12 sm6 md4 style="margin-top:40px;">
          <h2>Change password</h2>
          <v-form @submit="changePassword">
            <v-text-field
              v-model="currentPassword"
              type="password"
              ref="edit_password_current"
              label="Current password"
            />
            <v-text-field v-model="password" type="password" ref="edit_password" label="Password" />
            <v-text-field
              v-model="passwordRepeat"
              type="password"
              ref="edit_password_repeat"
              label="Repeat password"
            />
            <v-btn type="submit">
              <v-icon>save</v-icon>Change
            </v-btn>
          </v-form>
        </v-flex>
        <v-flex xs12 sm6 md4 style="margin-top:40px;">
          <h2>Sessions</h2>
          <p>Currently you have {{ active_sessions }} active session(s). <span v-if="active_sessions === 1">This is obviously the current session on this device.</span></p>
          <v-btn style="margin-left:auto;margin-right:auto;" @click="removeAllSessions" color="error">Delete all sessions</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { Profile } from "../logic/Profile";
import { User } from "../logic/User";
import { Notifications } from "../notification";

export default {
  name: "Profile",
  data() {
    return {
      email: "Loading...",
      currentPassword: "",
      password: "",
      passwordRepeat: "",

      firstName: "Loading...",
      lastName: "Loading...",

      active_sessions: 0
    };
  },
  mounted() {
    this.setTitle("Profile");
    this.loadProfileInformation();
  },
  methods: {
    async loadProfileInformation() {
      var data = (await Profile.load()).body;

      this.email = data.email;
      this.firstName = data.first_name;
      this.lastName = data.last_name;

      var session_data = await Profile.getActiveSessionsAmount();
      if (session_data.status === 200) {
        this.active_sessions = session_data.body;
      }
    },
    async removeAllSessions() {
      await User.removeAllSessions(this);
    },
    async changePassword(e) {
      e.preventDefault();

      if (
        this.currentPassword === "" ||
        this.password === "" ||
        this.passwordRepeat === ""
      ) {
        Notifications.show("Please fill out all fields.");
      } else if (this.password === this.passwordRepeat) {
        var response = await Profile.updatePassword(
          this.currentPassword,
          this.password
        );
        if (response.status === 200) {
          this.currentPassword = "";
          this.password = "";
          this.passwordRepeat = "";
          Notifications.show(response.message);
        } else {
          this.currentPassword = "";
          Notifications.show(response.message);
        }
      } else {
        Notifications.show("The new password does not match.");
      }
    },
    async saveDetails(e) {
      e.preventDefault();

      var response = await Profile.updateDetails(this.firstName, this.lastName);
      Notifications.show(response.message);

      return false;
    },
    back() {
      this.$router.replace("/dashboard");
    }
  }
};
</script>
<style scoped>
.flex {
  padding-right: 10px;
}
</style>